import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ServerEndpoints} from "../../../server.endpoints";

/** The platform-wide SumUp affiliate key (the vendor SDK key). */
export interface SumUpAffiliateKey {
  key: string | null;
}

/**
 * Reads/writes the platform-wide SumUp affiliate key (PlatformOwner only). The key is vendor-wide — the same for
 * the whole app — and is pushed to every device on login. Talks to the Owner-gated `/Management/SumUp/*` endpoints.
 */
@Injectable({providedIn: 'root'})
export class SumupAffiliateHttpService {
  constructor(@Inject("BASE_URL") private baseUrl: string, private httpClient: HttpClient) {
  }

  get(): Observable<SumUpAffiliateKey> {
    return this.httpClient.get<SumUpAffiliateKey>(`${this.baseUrl}${ServerEndpoints.Management_SumUp_GetAffiliateKey}`);
  }

  set(key: string): Observable<SumUpAffiliateKey> {
    return this.httpClient.put<SumUpAffiliateKey>(`${this.baseUrl}${ServerEndpoints.Management_SumUp_SetAffiliateKey}`, {key});
  }
}
